var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"root-trading-view"},[_c('div',{staticClass:"trading-view",class:{
      'chart-ready': _vm.isReady
    },attrs:{"id":_vm.containerId}}),(!_vm.isReady)?_c('div',{staticClass:"spinner-container"},[_c('spinner',{attrs:{"theme":"dark"}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }